import AttendanceReportComponent from 'components/Report/attendanceReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if needed

const AttendanceReportPage = () => {
	return (
		<PermissionGuard permission="Allow_Attendance_Report">
			<AttendanceReportComponent />
		</PermissionGuard>
	);
};

export default AttendanceReportPage;
